export default __webpack_public_path__ + "static/media/151-motorhome.ce9737d8.png";